import {ConversationApiModel} from '../../api/models/conversation.api.model';

type ReadState = Pick<ConversationApiModel, 'lastReadAtUserOne' | 'lastReadAtUserTwo'>;

/** A delayed snapshot or receipt must never undo an acknowledged read. */
export function mergeConversationReadState(previous: Partial<ReadState> | null | undefined,
                                          incoming: Partial<ReadState> | null | undefined): ReadState {
  const latest = (before: Date | undefined, after: Date | undefined): Date | undefined => {
    if (!before) return after;
    if (!after || !Number.isFinite(+new Date(after))) return before;
    return +new Date(before) > +new Date(after) ? before : after;
  };
  return {
    lastReadAtUserOne: latest(previous?.lastReadAtUserOne, incoming?.lastReadAtUserOne),
    lastReadAtUserTwo: latest(previous?.lastReadAtUserTwo, incoming?.lastReadAtUserTwo),
  };
}
